{
 "note": "made by tools/make-voice-script.py; do not edit",
 "voices": [
  "pa",
  "loud"
 ],
 "clips": {
  "pa-next-gtb-nagar": {
   "voice": "pa",
   "hi": "अगला स्टेशन गुरु तेग बहादुर नगर है।",
   "en": "The next station is G T B Nagar."
  },
  "pa-next-vishwa-vidyalaya": {
   "voice": "pa",
   "hi": "अगला स्टेशन विश्व विद्यालय है।",
   "en": "The next station is Vishwa Vidyalaya."
  },
  "pa-next-vidhan-sabha": {
   "voice": "pa",
   "hi": "अगला स्टेशन विधान सभा है।",
   "en": "The next station is Vidhan Sabha."
  },
  "pa-next-civil-lines": {
   "voice": "pa",
   "hi": "अगला स्टेशन सिविल लाइन्स है।",
   "en": "The next station is Civil Lines."
  },
  "pa-next-kashmere-gate": {
   "voice": "pa",
   "hi": "अगला स्टेशन कश्मीरी गेट है।",
   "en": "The next station is Kashmere Gate."
  },
  "pa-next-chandni-chowk": {
   "voice": "pa",
   "hi": "अगला स्टेशन चाँदनी चौक है।",
   "en": "The next station is Chandni Chowk."
  },
  "pa-next-chawri-bazaar": {
   "voice": "pa",
   "hi": "अगला स्टेशन चावड़ी बाज़ार है।",
   "en": "The next station is Chawri Bazaar."
  },
  "pa-next-new-delhi": {
   "voice": "pa",
   "hi": "अगला स्टेशन नई दिल्ली है।",
   "en": "The next station is New Delhi."
  },
  "pa-next-rajiv-chowk": {
   "voice": "pa",
   "hi": "अगला स्टेशन राजीव चौक है।",
   "en": "The next station is Rajiv Chowk."
  },
  "pa-next-patel-chowk": {
   "voice": "pa",
   "hi": "अगला स्टेशन पटेल चौक है।",
   "en": "The next station is Patel Chowk."
  },
  "pa-dock-left": {
   "voice": "pa",
   "en": "Doors will open on the left. Please mind the gap between the platform and the train.",
   "hi": "दरवाज़े बाईं ओर खुलेंगे। कृपया प्लेटफॉर्म और ट्रेन के बीच की दूरी का ध्यान रखें।"
  },
  "pa-dock-right": {
   "voice": "pa",
   "en": "Doors will open on the right. Please mind the gap between the platform and the train.",
   "hi": "दरवाज़े दाईं ओर खुलेंगे। कृपया प्लेटफॉर्म और ट्रेन के बीच की दूरी का ध्यान रखें।"
  },
  "pa-no-halt": {
   "voice": "pa",
   "en": "This train will not be halting at the next station.",
   "hi": "यह ट्रेन अगले स्टेशन पर नहीं रुकेगी।"
  },
  "pa-closed": {
   "voice": "pa",
   "en": "The next station is closed. Services are being regulated.",
   "hi": "अगला स्टेशन बंद है। सेवाएँ नियंत्रित की जा रही हैं।"
  },
  "pa-no-entry-exit": {
   "voice": "pa",
   "en": "Entry and exit at this station are closed until further notice.",
   "hi": "इस स्टेशन पर प्रवेश और निकास अगली सूचना तक बंद है।"
  },
  "pa-stay-on-board": {
   "voice": "pa",
   "en": "Passengers are requested to remain on board.",
   "hi": "यात्रियों से अनुरोध है कि वे ट्रेन में ही रहें।"
  },
  "pa-regret": {
   "voice": "pa",
   "en": "The inconvenience caused is regretted.",
   "hi": "हुई असुविधा के लिए खेद है।"
  },
  "pa-normal-shortly": {
   "voice": "pa",
   "en": "Normal service will resume shortly.",
   "hi": "सामान्य सेवा शीघ्र बहाल होगी।"
  },
  "pa-terminate-short": {
   "voice": "pa",
   "en": "This train will terminate at the previous station. Please alight.",
   "hi": "यह ट्रेन पिछले स्टेशन पर समाप्त होगी। कृपया उतर जाएँ।"
  },
  "pa-platform-male-1": {
   "voice": "pa",
   "only": "hi",
   "part": "the platform loop, line 1 of 8 (male)"
  },
  "pa-platform-male-2": {
   "voice": "pa",
   "only": "hi",
   "part": "the platform loop, line 2 of 8 (male)"
  },
  "pa-platform-male-3": {
   "voice": "pa",
   "only": "hi",
   "part": "the platform loop, line 3 of 8 (male)"
  },
  "pa-platform-male-4": {
   "voice": "pa",
   "only": "hi",
   "part": "the platform loop, line 4 of 8 (male)"
  },
  "pa-platform-male-5": {
   "voice": "pa",
   "only": "hi",
   "part": "the platform loop, line 5 of 8 (male)"
  },
  "pa-platform-male-6": {
   "voice": "pa",
   "only": "hi",
   "part": "the platform loop, line 6 of 8 (male)"
  },
  "pa-platform-male-7": {
   "voice": "pa",
   "only": "hi",
   "part": "the platform loop, line 7 of 8 (male)"
  },
  "pa-platform-male-8": {
   "voice": "pa",
   "only": "hi",
   "part": "the platform loop, line 8 of 8 (male)"
  },
  "pa-platform-female-1": {
   "voice": "pa",
   "only": "hi",
   "part": "the platform loop, line 1 of 8 (female)"
  },
  "pa-platform-female-2": {
   "voice": "pa",
   "only": "hi",
   "part": "the platform loop, line 2 of 8 (female)"
  },
  "pa-platform-female-3": {
   "voice": "pa",
   "only": "hi",
   "part": "the platform loop, line 3 of 8 (female)"
  },
  "pa-platform-female-4": {
   "voice": "pa",
   "only": "hi",
   "part": "the platform loop, line 4 of 8 (female)"
  },
  "pa-platform-female-5": {
   "voice": "pa",
   "only": "hi",
   "part": "the platform loop, line 5 of 8 (female)"
  },
  "pa-platform-female-6": {
   "voice": "pa",
   "only": "hi",
   "part": "the platform loop, line 6 of 8 (female)"
  },
  "pa-platform-female-7": {
   "voice": "pa",
   "only": "hi",
   "part": "the platform loop, line 7 of 8 (female)"
  },
  "pa-platform-female-8": {
   "voice": "pa",
   "only": "hi",
   "part": "the platform loop, line 8 of 8 (female)"
  },

  "pa-no-halt-patel": {
   "voice": "pa",
   "en": "This train will not be halting at Patel Chowk.",
   "hi": "यह ट्रेन पटेल चौक पर नहीं रुकेगी।"
  },
  "loud-ringsUp-0": {
   "voice": "loud",
   "en": "Surveillance perimeter active. Three rings. Assembly inside is not permitted.",
   "hi": "निगरानी घेरा सक्रिय। तीन घेरे। अंदर जमा होना मना है।"
  },
  "loud-metroClosed-60": {
   "voice": "loud",
   "en": "Janpath Gate 4 is closed.",
   "hi": "जनपथ गेट 4 बंद है।"
  },
  "loud-metroClosed-150": {
   "voice": "loud",
   "en": "Patel Chowk Gate 3 is closed.",
   "hi": "पटेल चौक गेट 3 बंद है।"
  },
  "loud-num-3": {
   "voice": "loud",
   "en": "Three.",
   "hi": "तीन।"
  },
  "loud-num-4": {
   "voice": "loud",
   "en": "Four.",
   "hi": "चार।"
  },
  "loud-num-5": {
   "voice": "loud",
   "en": "Five.",
   "hi": "पाँच।"
  },
  "loud-num-6": {
   "voice": "loud",
   "en": "Six.",
   "hi": "छह।"
  },
  "loud-num-7": {
   "voice": "loud",
   "en": "Seven.",
   "hi": "सात।"
  },
  "loud-num-8": {
   "voice": "loud",
   "en": "Eight.",
   "hi": "आठ।"
  },
  "loud-num-9": {
   "voice": "loud",
   "en": "Nine.",
   "hi": "नौ।"
  },
  "loud-num-10": {
   "voice": "loud",
   "en": "Ten.",
   "hi": "दस।"
  },
  "loud-num-11": {
   "voice": "loud",
   "en": "Eleven.",
   "hi": "ग्यारह।"
  },
  "loud-num-12": {
   "voice": "loud",
   "en": "Twelve.",
   "hi": "बारह।"
  }
 }
}
